import Subject from "../cse4sub/Subject";
import React from 'react'
import cse302m from '../assets/CSEASH302mid21.pdf'
import cse302e from '../assets/CSEASH302end21.pdf'

export default function Etc() {
  return (
    <div>
       <Subject title="Effective Technical Communication(ASH302)" mid="Q. Paper"
    book1="David F. Beer and David McMurrey, Guide to writing as an Engineer, John Willey. 
    New York, 2004 " 
    book2="Shiv Khera, You Can Win, Macmillan Books, New York, 2003.
    "
    book1Link="https://www.pdfdrive.com/download.pdf?id=34390978&h=75d8699c35f4c3efaf3d326b548f660e&u=cache&ext=pdf
    "
     book2Link="https://www.pdfdrive.com/download.pdf?id=24986464&h=0e56c98117c57f81cd5d21a78e358dba&u=cache&ext=pdf
     "
      int21="#" mid21={cse302m} end21={cse302e}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}